module.exports = __webpack_public_path__ + "static/redicon-769c82275c622ab79c8d470ddc991eb6.jpeg";